import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inr = (n) => `₹${(n || 0).toLocaleString('en-IN')}`;
const NOTIFY = { whatsapp_sent: 'WhatsApp', sms_sent: 'SMS', failed: 'Not sent', pending: 'Sending…' };

export const DonationsPanel = ({ token, onUnauthorized }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/admin/donations`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setData(res.data))
      .catch((e) => { if (e?.response?.status === 401) onUnauthorized(); });
  }, [token, onUnauthorized]);

  const totals = data?.totals;
  const cards = [
    { key: 'amount', label: 'Total Raised', value: totals && inr(totals.amount) },
    { key: 'month', label: 'This Month', value: totals && inr(totals.month_amount) },
    { key: 'count', label: 'Donations', value: totals && totals.count.toLocaleString('en-IN') },
  ];

  return (
    <section className="jbss-visit-stats" data-testid="admin-donations">
      <div className="jbss-visit-grid">
        {cards.map((c) => (
          <div className="jbss-visit-card" key={c.key} data-testid={`admin-donations-${c.key}`}>
            <span className="jbss-visit-label">{c.label}</span>
            <span className="jbss-visit-value">{c.value ?? '—'}</span>
          </div>
        ))}
      </div>
      {data && data.donations.length > 0 && (
        <div className="jbss-admin-table jbss-donation-list" data-testid="admin-donation-list">
          {data.donations.slice(0, 50).map((d) => (
            <div className="jbss-admin-trow" key={d.id} data-testid={`admin-donation-${d.id}`}>
              <div className="jbss-admin-tinfo">
                <span className="jbss-admin-tname">{d.name} · {inr(d.amount)}</span>
                <span className="jbss-admin-tmeta">
                  {d.receipt_no} · {d.phone} · {new Date(d.paid_at).toLocaleString('en-IN')} · Msg: {NOTIFY[d.notify_status] || '—'}
                </span>
              </div>
              <a className="jbss-admin-link" href={`${API}/donations/${d.id}/receipt`} target="_blank" rel="noreferrer">Receipt</a>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
